import axios, { AxiosResponse } from "axios";
import getConfig from "../../config/configUtil";
import { WorktimeResult } from "../../models/worktimeResult";

const conf = getConfig;

class WorkTimeService {
  async getWorkTimes(): Promise<WorktimeResult> {
    try {
      const response: AxiosResponse = await axios.get(conf.BACKEND + "admin/worktime/get");
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch work time settings");
    }
  }

  async saveWorkTimes(workTimes: WorktimeResult) : Promise<void> {
    try{
      await axios.post(conf.BACKEND + "admin/worktime/saveSchedule", workTimes);
    } catch (error) {
      console.log(error);
      throw new Error("Failed to save work time settings");
    }
  } 
  
  async imHere() : Promise<void> {
    try {
      await axios.post(conf.BACKEND + "admin/worktime/imHere");
    } catch (error) {
      console.log(error);
    }
  }
}

export default WorkTimeService;
